import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { GICreditHistoryItem } from "@/types/GICreditHIstoryItem";

interface GICreditHistoryState { items: GICreditHistoryItem[]; isLoading: boolean; }
const initialState: GICreditHistoryState = { items: [], isLoading: false };

export const getGICreditHistory = createAsyncThunk(
  "giCreditHistory/getGICreditHistory",
  async ({ address }: { address: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/giCreditHistory/${address}`);
    return response.data;
  }
);

const giCreditHistorySlice = createSlice({
  name: "giCreditHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGICreditHistory.pending, (state) => { state.isLoading = true; })
      .addCase(getGICreditHistory.fulfilled, (state, { payload }) => { state.items = payload; state.isLoading = false; })
      .addCase(getGICreditHistory.rejected, (state) => { state.isLoading = false; });
  },
});

export default giCreditHistorySlice.reducer;
